import React from 'react';
import { Text } from '@fluentui/react';
import { ThemeContext } from '../../HubLayout/models/ThemeContext';
import { getThemeFromString } from '../util/localStorageUtils';
import { useIsMobile } from '../hooks/useIsMobile';

interface IHubHeaderProps {
    title: string;
    subtitle?: React.ReactNode;
    actions?: React.ReactNode;
}

export const HubHeader: React.FC<IHubHeaderProps> = (
    props: IHubHeaderProps
) => {
    const themeContext = React.useContext(ThemeContext);
    const theme = getThemeFromString(themeContext.themeName);
    const isMobile = useIsMobile();

    return (
        <div
            style={{
                padding: isMobile ? '16px' : '16px 20px',
                backgroundColor: theme.palette.neutralQuaternary,
                borderBottom: `2px solid ${theme.palette.themeDark}`,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: '16px',
                flexWrap: isMobile ? 'wrap' : 'nowrap',
            }}
        >
            <div style={{ flex: 1 }}>
                <Text
                    variant="xLarge"
                    styles={{
                        root: {
                            fontWeight: 700,
                            color: theme.palette.black,
                        },
                    }}
                >
                    {props.title}
                </Text>
                {props.subtitle && (
                    <Text
                        variant="small"
                        styles={{
                            root: {
                                color: theme.palette.neutralSecondary,
                                marginTop: '4px',
                                display: 'block',
                            },
                        }}
                    >
                        {props.subtitle}
                    </Text>
                )}
            </div>
            {props.actions && <div>{props.actions}</div>}
        </div>
    );
};
